import React       from 'react';
import useDidMount from '@widesk-core/hooks/useDidMount';

type CallbackParams = { isLoaded: boolean; fetchAsync: () => Promise<void>; };

export default function useFetch<DATA>(callback: (params: CallbackParams) => Promise<DATA>, fetchOnMount = false) {
	const [isLoading, setIsLoading] = React.useState(fetchOnMount);
	const [isLoaded, setIsLoaded] = React.useState(false);
	const [error, setError] = React.useState<unknown>();

	const [data, setData] = React.useState<DATA>();

	const fetchAsync = async () => {
		setIsLoading(true);

		try {
			const data = await callback({ isLoaded, fetchAsync });
			setData(data);
			setError(undefined);
			setIsLoaded(true);
		} catch (err) {
			setError(err);

			throw err;
		} finally {
			setIsLoading(false);
		}
	};

	useDidMount(() => {
		if (fetchOnMount) {
			return fetchAsync();
		}
	});

	return { fetchAsync, isLoading, isLoaded, data, error };
}
